"use client";

import { CountryFlag } from "@/components/country-flag";
import type { RouterOutputs } from "@/types/rpc";

import type { artistResultMetadata } from "./artist-result-metadata";

type Artist = RouterOutputs["music"]["searchArtists"]["artists"][number];

export function ArtistResultMetadataView({
  artist,
  metadata,
}: {
  artist: Artist;
  metadata: ReturnType<typeof artistResultMetadata>;
}) {
  const show = metadata.showCountry || metadata.showRealname || metadata.showPrimaryStyleOrGenre;
  if (!show) return null;
  return (
    <div className="w-full flex flex-col items-center gap-0.5">
      {metadata.showCountry && (
        <span className="inline-flex max-w-full items-center gap-1 text-[11px] leading-tight text-muted-foreground">
          <CountryFlag code={artist.country} decorative size="sm" />
          <span className="max-w-full truncate">{metadata.countryName}</span>
        </span>
      )}
      {metadata.showRealname && (
        <span className="w-full truncate text-center text-[11px] leading-tight text-muted-foreground">
          {artist.realname}
        </span>
      )}
      {metadata.showPrimaryStyleOrGenre && (
        <span className="w-full truncate text-center text-[11px] leading-tight text-muted-foreground">
          {metadata.primaryStyleOrGenreLabel}
        </span>
      )}
    </div>
  );
}
